import { Component, OnDestroy, OnInit, signal } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  standalone: true,
  selector: 'app-bottom-bar',
  imports: [RouterModule],
  styles: [`
    :host { display: block; }

    .bottom-bar {
      position: fixed;
      left: 0;
      right: 0;
      bottom: 0;
      height: 34px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 12px;
      background: #2f8b82;
      color: #fff;
      font-size: 13px;
      z-index: 1000;
    }

    .left, .center, .right {
      display: flex;
      align-items: center;
      gap: 10px;
    }

    .eu-logo {
      height: 36px;
      width: auto;
      display: block;
    }

    .center {
      flex: 1;
      justify-content: center;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      padding: 0 10px;
      opacity: 0.95;
    }

    .home-link {
      display: inline-flex;
      align-items: center;
      gap: 6px;
      color: #fff;
      text-decoration: none;
      font-weight: 600;
      padding: 6px 10px;
      border-radius: 16px;
      background: rgba(255,255,255,0.12);
    }
    .home-link:hover { background: rgba(255,255,255,0.18); }
  `],
  template: `
    <div class="bottom-bar">
      <div class="left">
        <img class="eu-logo" src="logo/funded-by-the-EU.png" alt="European Union" />
      </div>

      <div class="center">
        {{ appName }} - {{ version }} - {{ now() }}
      </div>

      <div class="right">
        <a class="home-link" routerLink="/home">🏠 Home</a>
      </div>
    </div>
  `,
})
export class BottomBarComponent implements OnInit, OnDestroy {
  appName = 'VIGIMARE';
  version = '0.2.18';

  now = signal('');
  private timerId?: number;

  ngOnInit() {
    const tick = () => this.now.set(this.formatNow());
    tick();
    this.timerId = window.setInterval(tick, 1000);
  }

  ngOnDestroy() {
    if (this.timerId) window.clearInterval(this.timerId);
  }

  private formatNow(): string {
    const d = new Date();
    const dd = String(d.getDate()).padStart(2, '0');
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const yyyy = d.getFullYear();
    const hh = String(d.getHours()).padStart(2, '0');
    const min = String(d.getMinutes()).padStart(2, '0');
    return `${dd}-${mm}-${yyyy} ${hh}:${min}`;
  }
}
